import request from '@/utils/request'

// 获取大屏事件类型
export function zidianliebia(query) {
  return request({
    url: '/daping/haikdictlist',
    method: 'get',
    params: query
  })
}